module.exports = __webpack_public_path__ + "media/images/application2/AppNav__panel__gray__publisher__p__span--verified-77da5de4244161dfdb44f506c495894c.svg";